export const ADMIN_SETTINGS_KEY = "matlib-admin-settings";
export const DEFAULT_PRICE_MIN = 1.5;
export const DEFAULT_PRICE_MAX = 3.0;

function clampPrice(value, fallback) {
  const number = Number(value);
  if (!Number.isFinite(number) || number < 0) {
    return fallback;
  }
  return Math.round(number * 100) / 100;
}

export function normalizePriceBounds(min, max) {
  const priceMin = clampPrice(min, DEFAULT_PRICE_MIN);
  const priceMax = clampPrice(max, DEFAULT_PRICE_MAX);
  if (priceMin >= priceMax) {
    return { priceMin: DEFAULT_PRICE_MIN, priceMax: DEFAULT_PRICE_MAX };
  }
  return { priceMin, priceMax };
}

export function getAdminSettings() {
  const fallback = {
    priceMin: DEFAULT_PRICE_MIN,
    priceMax: DEFAULT_PRICE_MAX,
  };
  if (typeof window === "undefined") {
    return fallback;
  }

  try {
    const raw = window.localStorage.getItem(ADMIN_SETTINGS_KEY);
    if (!raw) {
      return fallback;
    }
    const parsed = JSON.parse(raw);
    return normalizePriceBounds(parsed?.priceMin, parsed?.priceMax);
  } catch (error) {
    return fallback;
  }
}

export function saveAdminSettings({ priceMin, priceMax }) {
  const next = normalizePriceBounds(priceMin, priceMax);
  if (typeof window !== "undefined") {
    window.localStorage.setItem(ADMIN_SETTINGS_KEY, JSON.stringify(next));
  }
  return next;
}
